import type { ReactNode } from 'react';
import { Heading } from '../ui/index';

interface PageTitleProps {
  title: string;
  actions?: ReactNode;
  subtitle?: string;
}

export const PageTitle = ({ actions, subtitle, title }: PageTitleProps) => {
  return (
    <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
      <div className="min-w-0">
        <Heading className="m-0" level={1}>{title}</Heading>
        {subtitle && <p className="m-0 mt-2 max-w-3xl text-sm text-neutral-secondary-foreground">{subtitle}</p>}
      </div>
      {actions && <div className="flex shrink-0 gap-2">{actions}</div>}
    </div>
  );
}
